'use client';
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Column(_props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}
Column.displayName = 'Table.Column';
Column.defaultProps = {
  width: 100
};
export var columnHandledProps = ['align', 'verticalAlign', 'width', 'fixed', 'resizable', 'sortable', 'flexGrow', 'minWidth', 'colSpan', 'rowSpan', 'treeCol', 'onResize', 'children', 'fullText'];
export default Column;